<template>
  <article class="order_details">
    <modal title="操作提示" v-model="changeModal.Show" :mask-closable="false" @on-ok="changeFrequency(changeModal.info, changeModal.fre)">
      <!--      <p>
        每位乘客于班车发车前半小时可更改班次一次，更改后将不可再变更班次；去程接送订单变更一位乘客班次则会对订单内其他乘客一同变更到新的班次里，请谨慎操作！请问是否要变更班次？
      </p> -->
    </modal>
    <header class="pages_title">
      <h3>订单号:{{orderData.OrderNum}}</h3>
    </header>

    <section class="order_details_container">
      <div class="order_details_passenger_separation flex_wrap">
        <h3>订单详情</h3>
      </div>
      <div class="order_details_route">
        <div class="order_details_route_info">
          <p class="">
            <span>出发城市:</span>
            <span>{{orderData.DesCity}}</span>
          </p>
          <p class="">
            <span>到达城市 :</span>
            <span>{{orderData.OriCity}}</span>
          </p>
          <p class="">
            <span>出发时间 :</span>
            <span>{{orderData.DepDate}}</span>
          </p>
          <p class="" v-if="orderData.FlightType==2">
            <span>返程时间 :</span>
            <span>{{orderData.BackDate}}</span>
          </p>
          <p class="">
            <span>出发航班 :</span>
            <span>{{orderData.DepFlightNo}}</span>
          </p>
          <p class="" v-if="orderData.FlightType==2">
            <span>返程航班 :</span>
            <span>{{orderData.BackFlightNo}}</span>
          </p>
          <p class="">
            <span>总价 :</span>
            <span class="text_wrapping">{{orderData.TotalAmount}}元</span>
          </p>
          <p class="">
            <span>订单进度 :</span>
            <span class="text_wrapping">{{orderState[orderData.OrderState]}}</span>
          </p>
          <p class="">
            <span>联系人 :</span>
            <span class="text_wrapping">{{orderData.Contact}}</span>
          </p>
          <p class="">
            <span>联系电话 :</span>
            <span class="text_wrapping">{{orderData.Mobile}}</span>
          </p>
          <p class="" v-if="orderData.OrderType==2 || orderData.OrderType==3 || orderData.OrderType==4">
            <span>司机：</span>
            <span class="text_wrapping">{{orderData.DriverName}}</span>
          </p>
          <p class="">
            <span>下单时间：</span>
            <span class="text_wrapping">{{(orderData.CreateDate)}}</span>
          </p>
          <div class='route_info_items flex_wrap' v-if="(orderData.OrderState==2) && orderData.Status && orderData.OrderState!=4"
            style="height:10vh;flex-wrap: wrap;justify-content:normal;">
            <span class='cancel_hint red_text'>若需要取消订单退款请于航班发班前操作!</span></br>
            <span style="color:red;">*退票备注(必填)：</span>
            <input type="text" class="Remark" v-on:keyup="inputReamrk" placeholder='请填写退票备注（必填）' />
          </div>
          <div class='route_info_items flex_wrap' v-if="(orderData.OrderState==2) && orderData.Status && orderData.OrderState!=4">

          <span style="">
            <button class='del_order_btn' hover-class='h_del_order_btn' @click="authRefundMessage(orderData)">自愿退票</button>
            <p style="color:red;border-bottom: 2px solid #a7a7a7;">旅客由于本人原因，在客票有效期内不能完成部分或全部航程，而要求办理退票手续；</p>
          </span>

          <span style="">
            <button class='del_order_btn' hover-class='h_del_order_btn' @click="authRefundMessage1(orderData)">非自愿退票
            </button>
            <p style="color:red;">旅客由于航班取消、提前、延误、航程改变、病退等非旅客因素导致的，在客票有效期内不能完成部分或全部航程，而旅客要求退票;</p>
          </span>

          </div>

          <!--          <p class="" v-if="false">
            <span class="red_color">重要提示 :</span>
            <span class="text_wrapping">XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX</span>
          </p>
          <div class="order_details_function_btns flex_wrap a_i_center" v-if="false">
            <button class="little_btn function_btn_primary_color">班次变更</button>
            <button class="little_btn function_btn_wx_color">乘客签到</button>
            <button class="little_btn function_btn_pj_color">服务评价</button>
          </div> -->
        </div>
      </div>

      <div class="order_details_passenger_separation flex_wrap">
        <h3>乘客信息</h3>
      </div>
      <template v-for="(infoItem, index) in orderData.FlightOrderList_Passengers">
        <div :key="index + 'i'" class="order_details_passenger_wrap">
          <div class="order_details_passenger_information flex_wrap">
            <p class="name">
              <span>乘机人 :</span>
              <span>{{ infoItem.PsgName }}</span>
              <span>证件类型 :</span>
              <span>{{ papersType[infoItem.PapersType] }}</span>
            </p>
<!--            <p class="type">


            </p> -->
            <p class="idnum">
              <span>证件号 :</span>
              <span>{{ infoItem.CardNO }}</span>
            </p>
          </div>

          <template v-for="(freItem, j) in infoItem.FlightOrderList_PsgSegments">
            <div :key="j + 's'" class="hodometer">
              <p class="separation_title">第{{ j + 1 }}程</p>
            </div>


            <div class='route_list flex_wrap j_c_between'>
              <div class='route_list_left'>
                <span class='primary_text'>{{freItem.DepDate}}起飞</span>
                <span class='primary_text'>{{freItem.ArrDate}}到达</span>
              </div>
              <div class='route_list_center' style="flex-wrap: wrap;">
                <span class='site_name_w dark_grey_text' style="width:8em;color:#2F2F2F">{{orderData.DepFlightNo == freItem.FlightNo?orderData.DesCity:orderData.OriCity}}-{{freItem.DepAirportName}}</span>
                <!-- <text class='iconreversal iconfont icon-jiantou_qiehuanyou dark_grey_text'></text> -->
                <span class='site_name_w dark_grey_text' style="width:8em;color:#2F2F2F">{{orderData.DepFlightNo == freItem.FlightNo ? orderData.OriCity: orderData.DesCity }}-{{freItem.ArrAirportName}}</span>
              </div>
              <div class='route_list_right j_c_between a_i_center' style="flex-wrap: wrap;">
                <span class='red_text' style="margin-right: 10px;">航班号:{{freItem.FlightNo}}</span>
                <span class='red_text'>票号:{{freItem.TicketNumber}}</span>
                <!-- <button bindtap='changeFrequency' data-infoitem="{{infoItem}}" data-freitem="{{freItem}}" hover-class='h_little_btn' class='function_btn function_btn_primary_color' disabled="{{freItem.Checked}}" wx:if="{{freItem.ChangeTimes==0 && !freItem.Checked}}">变更航班</button> -->
              </div>
            </div>


            <!--            <div :key="j + 'a'" class="route_list flex_wrap j_c_between a_i_center">
              <div class="route_list_left flex_wrap column a_i_center">
                <span class="">{{ freItem.SetDate }}</span>
                <span class="primaryColor-text">{{ freItem.Time }}</span>
              </div>
              <div class="route_list_center flex_wrap">
                <span class="site_name_w">{{ freItem.FromPlace }}</span>
                <i class="iconreversal iconfont icon-jiantou_qiehuanyou"></i>
                <span class="site_name_w">{{ freItem.ToPlace }}</span>
              </div>
              <div class="route_list_right flex_wrap j_c_between a_i_center">
                <p class="">
                  <span class="red-text">&yen;{{ freItem.Price }}</span>
                </p>
              </div>
            </div> -->
          </template>
        </div>
      </template>
    </section>
  </article>
</template>

<script>
  import flightApi from '../request/flightApi';
  import baseTool from '../utils/baseFunction';
  import eventApi from '@/request/eventApi';

  export default {
    name: 'FlightOrderDetailsInfo',
    data() {
      return {
        orderData: {},
        orderId: '',

        orderState: ['等待支付', '已支付，等待出票！', '已出票', '申请退票', '已退票'],
        papersType: ['', '身份证', '护照', '', '港澳通行证', '台胞证', '', '回乡证', '军官证', '其他'],

        imgSuffix: '',
        changeModal: {
          Show: false,
          info: null,
          fre: null
        }
      };
    },
    activated() {
      this.orderId = this.$route.params.id;
      this.getOrderData();
    },
    methods: {
      getOrderData() {
        let that = this;
        flightApi.getFlightOrderDetail(this.$store.state.user.OpenId, this.orderId).then(sucRes => {
          if (sucRes.success) {
            let val = sucRes.data;
            val.DepDate = baseTool.formatDateStr(val.DepDate, "full");
            val.CreateDate = baseTool.formatDateStr(val.CreateDate, "full");
            if (val.BackDate) {
              val.BackDate = baseTool.formatDateStr(val.BackDate, "full");
            }
            val.FlightOrderList_Passengers.forEach(psg => {
              psg.FlightOrderList_PsgSegments.forEach(seg => {
                seg.DepDate = baseTool.formatDateStr(seg.DepDate, 'time');
                seg.ArrDate = baseTool.formatDateStr(seg.ArrDate, 'time');
              })
            })
            this.orderData = val
          } else {
            alert('获取订单信息失败');
          }
        })
      },
      inputReamrk(e) {
        // console.log(e)
        this.orderData.Remark = e.target.value
        // console.log(e.target.value)
      },
      //机票自愿退票
      authRefundMessage(ev) {
        // console.log(ev)
        if (this.orderData.Remark == null || this.orderData.Remark == '') {
          alert('退票备注未填写，不得申请退票，请先填写备注！')
        } else {
          this.applyFlightRefund(ev);
        }
      },
      //机票非自愿退票
      authRefundMessage1(ev) {
        if (this.orderData.Remark == null || this.orderData.Remark == '') {
          alert('退票备注未填写，不得申请退票，请先填写备注！')
        } else {
          this.applyFlightRefund1(ev);
        }
      },


      //机票自愿退票
      applyFlightRefund(e) {
        let that = this;
        // let order = e.currentTarget.dataset.item;
        let Type = 1
        let attachmentPath = ''
        if (that.orderData != undefined) {
          // console.log(order)
          if (confirm(
              "1. 旅客由于本人原因，在客票有效期内不能完成部分或全部航程，而要求办理退票手续；旅客申请自愿退票，按航空公司退票规则收取退票费，退票费提供收据不提供发票。若已打印行程单的需先归还行程单；\n2. 退还部分为扣除退票费后的未使用航段的票款以及相关燃油附加费和机场建设费，订票服务费不做退还；",
              "自愿退票规则")) {
            if (confirm(
                '1. 自愿退票正常情况下为7-10个工作日完成退票退款流程，票款按原路返还；\n2. 客服热线：0760-88880777（工作时间：08:00-18:00），24小时紧急联系电话：18988598936。',
                '重要提示')) {
              flightApi.refundFlightOrder(that.$store.state.user.OpenId, that.orderData.OrderNum, Type, that.orderData.Remark,
                attachmentPath).then(sucRes => {
                if (sucRes.success == true) {
                  if (confirm(sucRes.message)) {
                    that.$router.go(-1);
                  }
                } else {
                  alert(sucRes.message)
                }
              })
            }
          }
        }
      },

      //机票自愿退票
      applyFlightRefund1(e) {
        let that = this;
        // let order = e.currentTarget.dataset.item;
        let Type = 2
        let attachmentPath = ''
        if (that.orderData != undefined) {
          // console.log(order)
          if (confirm(
              "1. 由于航班取消、提前、延误、航程改变、病退等非旅客因素导致的，旅客要求退票，均不收取退票费、订票服务费，若已打印行程单的需先归还行程单；\n2. 非自愿退票需上传航班延误或取消凭证，病退需提供医疗单位的证明等文件;",
              "非自愿退票规则")) {
            if (confirm(
                '1. 非自愿退票正常情况下为10-18个工作日完成退票退款流程，票款按原路返还；\n2. 客服热线：0760-88880777（工作时间：08:00-18:00），24小时紧急联系电话：18988598936。',
                '重要提示')) {
              var tmpImageID
              wx.chooseImage({
                count: 1, // 默认9
                sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
                sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
                success: chooseRes => {
                  console.log('chooseRes=>', chooseRes);
                  let localIds = chooseRes.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                  tmpImageID = localIds[0];
                  console.log(tmpImageID)
                  wx.uploadImage({
                    localId: tmpImageID, // 需要上传的图片的本地ID，由chooseImage接口获得
                    isShowProgressTips: 1, // 默认为1，显示进度提示
                    success: uploadRes => {
                      console.log('uploadRes=>', uploadRes);
                      // that.CredentialsUrlID = uploadRes.serverId; // 返回图片的服务器端ID
                      eventApi.getH5UploadImagePath(that.$store.state.user.OpenId, uploadRes.serverId).then(
                        sucRes => {
                          if (sucRes.success == true) {
                            attachmentPath = sucRes.data;
                            flightApi.refundFlightOrder(that.$store.state.user.OpenId, that.orderData.OrderNum,
                              Type, that.orderData.Remark, attachmentPath).then(upSucRes => {
                              if (upSucRes.success == true) {
                                if (confirm(upSucRes.message)) {
                                  that.$router.go(-1);
                                }
                              } else {
                                alert(upSucRes.message);
                              }
                            })
                          } else {
                            alert(sucRes.message);
                          }
                        })
                    }
                  })
                }
              })
            }
          }
        }
      },



    },
  };
</script>

<style scoped lang="less">
  @import '../style/public';

  .order_details_passenger_separation {
    height: 4vh;
    line-height: 4vh;
    background-color: #006535;
    color: #fff;
    margin-top: 1em;
    font-size: 0.35rem;
    .flex_wrap(center, center);
  }

  /*.order_details_passenger_separation,.order_details_route_info,.order_details_passenger_wrap{
  	border-radius: 6px;
  }*/
  .order_details_passenger_separation>h3 {
    letter-spacing: 2px;
    text-indent: 2px;
  }

  .order_details_route>div {
    padding: 0 1em;
  }

  .order_details_route_info {
    flex-direction: column;
    background-color: #f8f8f8;
    border: 1px solid #ddd;
    margin-top: 1em;
  }

  .order_details_route_info p:first-child {
    margin-top: 0.5em;
  }

  .order_details_route_info p {
    line-height: 4vh;
  }

  .order_details_route_info p:last-of-type {
    margin-bottom: 0.5em;
  }

  .order_details_function_btns {
    border-top: 1px dashed #888;
    padding: 0.5em 0 0;
    flex-wrap: wrap;
  }

  .order_details_function_btns .little_btn {
    letter-spacing: normal;
    text-indent: inherit;
    margin: 0 0.5em 0.5em 0;
    border-color: transparent;
    /*padding: 3px 4px;*/
  }

  .function_btn_primary_color {
    background-color: #17abe3;
    color: #fff;
  }

  .function_btn_primary_color:active {
    background-color: #006535;
    color: #e4e4e4;
  }

  .function_btn_wx_color {
    background-color: #09bb07;
    color: #fff;
  }

  .function_btn_wx_color:active {
    background-color: #00b780;
    color: #e4e4e4;
  }

  .function_btn_pj_color {
    background-color: #e42121;
    color: #fff;
  }

  .function_btn_pj_color:active {
    background-color: #cc1e1e;
    color: #e4e4e4;
  }

  .order_details_passenger_wrap {
    border: solid #ddd;
    border-width: 1px 1px 0;
    background-color: #f8f8f8;
    margin: 10px 0;
    flex-wrap: wrap;
    box-sizing: border-box;
    .flex_wrap(space-between, initial, wrap);
  }

  .order_details_passenger_information {
    flex-wrap: wrap;
    flex: 0 0 75%;
    padding: 0.5em 0;
  }

  .order_details_checking {
    flex: 0 0 25%;
    border-left: 1px solid #ddd;
    .flex_wrap(center, center, initial, column);
  }

  .order_details_checking .iconfont {
    font-size: 0.6rem;
  }

  /*.order_details_passenger_information>.name{
  	flex: 0 0 40%;
  }
  .order_details_passenger_information>.type{
  	flex: 0 0 40%;
  }*/
  .order_details_passenger_information {
    .flex_wrap(initial, initial, wrap);
  }

  .order_details_passenger_information>p {
    padding: 0 10px;
    line-height: 4vh;
  }

  .order_details_passenger_information>.update_service_item>.iconfont {
    margin-left: 0;
  }

  .hodometer {
    flex: 0 0 100%;
    border: solid #ddd;
    border-width: 1px 0;
  }

  .order_details_passenger_wrap .separation_title {
    width: inherit;
    margin: 0;
    padding: 0;
    text-align: center;
  }

  .route_list {
    font-size: 0.32rem;
    flex: 0 0 100%;
    border-bottom: 1px solid #ddd;
    height: 7vh;
    padding: 0.5em;
    .flex_wrap(space-between, center);
  }

  .route_list>div {
    /*line-height: 4vh;*/
  }

  .route_list_left {
    flex: 0 0 auto;
    margin-right: 0.5em;
    .flex_wrap(initial, center, initial, column);
  }

  .route_list_center {
    .flex_wrap;
  }

  .route_list_center .iconfont {
    // margin: 0 5px;
  }

  .route_list_right {
    .flex_wrap(space-between, center, initial);

    &>.little_btn {
      letter-spacing: normal;
      text-indent: inherit;
      border-color: transparent;
      padding: 0 5px;
      margin-right: 0;
    }
  }

  .order_details_passenger_wrap {
    font-size: 0.35rem;
  }

  .route_list {
    padding: 0 2%;
    /* margin: 5rpx 0; */
    background-color: #f8f8f8;
    border: solid #ddd;
    border-width: 1px 0;
    /* box-shadow: 0 0 5rpx rgba(0, 0, 0, .5); */
    align-items: center;
    height: 8vh;
  }

  .ticket_changing_list span {
    font-size: 12px;
  }

  .ticket_changing_list div {
    text-align: center;
  }

  .route_list_left {
    width: 22%
  }

  /* .route_list_center {
    width: 35%;
    justify-content: flex-start;
    align-items: center;
  } */

  .route_list_left span {
    display: block;
    line-height: initial;
  }

  .route_list_center {
    width: 35%;
    justify-content: flex-start;
    align-items: center;
    padding-left: 5px;
  }

  .route_list_center span {
    display: block;
    line-height: initial;
  }

  .route_list_right span {
    display: block;
    line-height: initial;
  }

  .route_list_right .function_btn {
    margin: 0;
  }

  .route_list_right .site_name_w {
    width: 4.5em
  }

  .del_order {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 6vh;
    padding: 5px 3%;
    /* background-color: #f8f8f8; */
    border-bottom: 1px solid rgba(0, 0, 0, .3);
  }

  .del_order_btn {
    margin: 0;
    font-size: 12px;
    border-radius: 0;
    /* height: 4vh; */
    line-height: 4vh;
    margin-right: 5px;
    padding: 2.5px 5px;
    border-radius: 5px;
  }

  .del_order_btn {
    background-color: #e42121;
    color: #fff;
    border: 2px solid white;
    margin-top: 2px;
    margin-bottom: 5px;
  }

  .del_order_btn>.iconfont {
    margin: 0 2.5px
  }

  .h_del_order_btn {
    background-color: #cc1e1e;
    color: #e4e4e4;
  }

  .cancel_hint {
    // margin-left: 3%;
    margin-right: 10%;
  }

  .Remark {
    margin-top: 5px;
    margin-bottom: 5px;
    border: 1px solid #888888;
    border-radius: 5px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/FlightOrderDetailsInfo.vue